import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { GiftCardTransactionsFragment } from '@/gql/generated';
import { formatDateToTimezone } from '@/lib/timezone';
import { formatNumberToCurrency, formatPhoneNumber } from '@/lib/utils';
import { AuthenticatedContext } from '@/pages/(gapsdk)/(authenticated)/_provider/authenticated-provider';
import { transactionsType } from '@/utils/constant';
import { formatCodeGiftCard } from '@/utils/gift-card';
import { formatDate } from 'date-fns';
import { useContext } from 'react';

const ManualReceiptDetail = (props: {
  isOpen: boolean;
  onClose: () => void;
  data: GiftCardTransactionsFragment;
}) => {
  const { crmCompany, user } = useContext(AuthenticatedContext);
  const paymentMethod = props?.data?.payment_methods[0];
  return (
    <Dialog open={props.isOpen} onOpenChange={() => props.onClose()}>
      <DialogContent className="max-h-[46rem] overflow-auto">
        <DialogHeader className="px-2">
          <DialogTitle className="text-3xl font-bold">
            Receipt Details
          </DialogTitle>
        </DialogHeader>
        <div className="my-3 border-b border-gray-border"></div>
        <div className="text-base">
          <div className="pb-4 text-center">
            <div className="pb-3 text-xl font-bold">{crmCompany?.name}</div>
            <div>{crmCompany?.address}</div>
            <div>{formatPhoneNumber(crmCompany?.phone ?? '')}</div>
          </div>

          <div className="font-semibold">
            Transaction ID: {props?.data?.code}
          </div>
          <div>
            DateTime:{' '}
            {formatDateToTimezone(
              props?.data?.date,
              user?.time_zone!,
              'MM/dd/yyyy hh:mm a',
            )}{' '}
          </div>
          <div className="my-5 border-t-2 border-dashed border-gray-border"></div>
          <div className="flex gap-1">
            <p>Gift Code:</p>
            <p>
              {props.data.gift_card?.pos_gift_card?.code
                ? formatCodeGiftCard(
                    props.data.gift_card?.pos_gift_card?.code,
                    false,
                  )
                : formatCodeGiftCard(props.data.gift_card?.code ?? '', true)}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p>Amount:</p>
            <p>
              {props.data?.type === transactionsType.TOP_UP
                ? formatNumberToCurrency(props.data?.price)
                : formatNumberToCurrency(props.data?.balance_change)}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p>TOTAL:</p>
            <p>
              {props.data?.type === transactionsType.TOP_UP
                ? formatNumberToCurrency(props.data?.price)
                : formatNumberToCurrency(props.data?.balance_change)}
            </p>
          </div>
          <div className="my-5 border-t-2 border-dashed border-gray-border"></div>

          <p className="text-center font-bold">Payment Details</p>
          <p className="capitalize">Action: Manually Entered</p>
          <p>Status: Sale</p>
          <div className="my-5 border-t-2 border-dashed border-gray-border"></div>
          <p className="text-center font-bold">Payment Method</p>

          <p>
            Expiration Date:{' '}
            {paymentMethod?.card_info?.expiration_date &&
              formatDate(paymentMethod?.card_info?.expiration_date, 'MM/yyyy')}
          </p>
          <div>
            Card last four:{' '}
            {paymentMethod?.card_info?.card_number_last_four ?? '/'}
          </div>
          <div className="my-5 border-t-2 border-dashed border-gray-border"></div>
          <p className="text-center font-bold">Transactions</p>
          <p>Auth code: {paymentMethod?.auth_code}</p>
          <p>Trans ID: {paymentMethod?.reference_id}</p>
          <p>Trans message: {paymentMethod?.trans_message}</p>

          <div className="py-4">Signature</div>
          {props.data.signature?.base_uri && (
            <img
              src={props.data.signature?.base_uri}
              alt={props.data.signature?.name ?? ''}
              width={300}
              height={250}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ManualReceiptDetail;
